module.exports = __webpack_public_path__ + "static/media/img-consumidor3.40d1bdeb.40d1bdeb.JPG";